import { all, takeLatest, put, takeEvery } from 'redux-saga/effects'
import { notification } from 'antd'
import { request } from '../../../../admincore'
import { createOrder } from '../../api'
import { actions } from './actions'

function* CREATE({ payload: { id, params } }) {
  yield put(request(createOrder(id, params), actions.LOAD))
}

function* SUCCESS() {
  // yield notification.success({
  //   message: payload.intl.formatMessage({ id: 'redux.toast.done' }),
  //   description: payload.intl.formatMessage({ id: 'shifts.redux.opened' }),
  // })
  yield notification.success({
    message: 'Done!',
    description: 'Order sent.',
  })
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, CREATE), takeLatest(actions.SUCCESS, SUCCESS)])
}
